export function SAVE_FILTERS(state, [progress, search, selected_areas, selected_groups, selected_tags]){
    state.progress = progress
    state.search = search
    state.selected_areas = selected_areas
    state.selected_groups = selected_groups
    state.selected_tags = selected_tags
}

export function SAVE_LIVE_CLASS_STATUS(state, [live_class_status]){
    state.live_class_status = live_class_status
}

export function SAVE_LIVE_CLASS_IS_ONLINE(state, [live_class_is_online]){
    state.live_class_is_online = live_class_is_online
}

export function SAVE_PROGRESS(state, progress){
    state.progress = progress
}

export function SAVE_FILTER_AREA(state, selected_areas){
    state.selected_areas = selected_areas
}

export function SAVE_LOADING(state, loading){
    state.loading = loading
}